export const REGEX = {
  BOLD_TEXT: /^(?![\d-])(.+):/,
  BOLD_TEXT_ROMAN_NUMERAL: /^[IVXLCDM]+\.\s.+$/,
  SECTION_TITLE:
    /^(Learning across curriculum|Review Motivation|Sample ideas\/questions to assess the activities|Engage|Explore|Explain|Elaborate|Evaluate|Elicit|Extend|Assignment|Activity|Analysis|Abstraction|Application|Assessment|Activity|Wrap Up|Introductory Activity):/,
  DETECT_ASES_TEXT:
    /^(Engage|Explore|Explain|Elaborate|Evaluate|Elicit|Extend|Abstraction|Analysis|Application|Assessment|Introductory Activity|Activity|Wrap Up|Wrap-Up Remarks|Assignment|Energizer):/,
  DETECT_ASES_FILIPINO_TEXT:
    /^(Pakikilahok|Pagtuklas|Paliwanag|Pagpapalawak|Pagtataya|Pagpukaw ng Interes):/,
  DETECT_ACTIVITY_SECTION_4AS: /Activity:/,
  DETECT_ACTIVITY_SECTION_5OR7ES: /Explore:([\s\S]*?)(?=Explain:|$)/,
  DETECT_ACTIVITY_ITEM_FOR_ELABORATION: /^Activity \d+: /,
  IDENTIFY_SECTION_TITLE_4AS: /^Activity:(.*)/m,
  IDENTIFY_SECTION_TITLE_5OR7ES: /^Explore:(.*)/m,
  ISOLATE_SECTION_TITLE_4AS: /Activity:\n([\s\S]*)/m,
  ISOLATE_SECTION_TITLE_5OR7ES: /Explore:\n([\s\S]*)/m,
  EXEMPT_CONTENT_ACTIVITY: /^Activity:(.*)/m,
  EXPLORE_END_SECTION_TITLE_4AS: /^Analysis:(.*)/m,
  EXPLORE_END_SECTION_TITLE_5OR7ES: /^Explain:(.*)/m,
  DETECT_UP_TO_BEFORE_EXPLAIN: /^([\s\S]*?)(?=Explain:|$)/,
  NUMBER_PATTERN: /^(\d+)(\)|\.)\s/,
  LETTER_PATTERN: /^([A-D])\.\s/,
  SUBITEM_PATTERN: /^\s+-/,
  BRACKET_ENCLOSED: /\[(.*?)\]/,
  NUMBERED_REFERENCE: /\[(\d+)\]/g,
  NUMBERED_ITEMS: /(\d+\.\s[^0-9]+)/g,
  VALID_TEXT_INPUT: /^[A-Za-z0-9.,;:'"()?\-+_=/^\s[\]%!]+$/,
  INVALID_TEXT_INPUT: /[^A-Za-z0-9.,;:'"()?\-+_=/^\s[\]%!]/g,
  SANITIZE_ID: /[^a-zA-Z0-9_-]/g,
  REMOVE_WHITESPACE: /\s+/g,
  ACCORDION_BOLD_TEXT: /^(?:(?:\d+\.\s+)?[^:]+):/,
  TOPIC_EXPLORER_SECTION_TITLE:
    /^(Definition and Objectives|Key Components|Historical Context|Historical Development|Challenges|Current Challenges|Summary)\s*$/,
  BULLET_PATTERN: /\[(.*?)\]\(\*\)/g,
  NUMBERED_PATTERN: /\[(.*?)\]\((\d+)\)/g,
  UNIT_PLAN_SECTION_TITLE:
    /^(Global Context|Statement of Inquiry|Inquiry Questions|Key Concepts|Key Concept|Related Concepts|Learner Profile Attributes|Approaches to Learning \(ATL\)|Learning Goals|Interdisciplinary Connections|Service as Action|Reflection|Transdisciplinary Theme|Central Idea|Lines of Inquiry|Teaching Learning Activities|Assessment|Action|Theory of Knowledge \(TOK\) Connections|International-Mindedness|Learning Goals & Assessment Objectives|Real-World Applications):\s*(.*)/,
  LEADING_STRING: /^([\s\S]*?)(?=\s*\[.*?\]\(.*?\))/,
  ACTIVITY_WITH_TIME: /^activity\s+1\s+\(\d+\s+minutes?\)/i,
  MAIN_SECTION_HEADER: /^[IVX]+\.\s/,
  ESCAPED_NEWLINE: /\\n/g,
  VALID_COUNTRY_CODE: /^[A-Z]{2}$/i,
  WWW_PREFIX: /^www\./,
  DOMAIN_EXTENSIONS: /\.(com|org|net|gov|edu|io|co\.uk|ac\.uk|mil)$/,
  CLEAN_PATH: /^\/[^/]+/,
  CLEAN_THREAD_PATH: /\//g,
  DETECT_DLL_DAY_START: /day:\s*(monday|tuesday|wednesday|thursday|friday)/i,
  DETECT_DLL_DAY_START_FILIPINO:
    /araw:\s*(lunes|martes|miyerkules|huwebes|biyernes)/i,
};
